const COLUMNS_GROUPS = [
  {
    id: "date",
    label: "Date",
    widget: "date",
    width: 150
  },
  {
    id: "purchaseOrder",
    label: "Purchase Order#",
    widget: "text",
    width: 200
  },
  {
    id: "reference",
    label: "Reference#",
    widget: "text",
    width: 200
  },
  {
    id: "vendorName",
    label: "Vendor Name",
    widget: "text",
    width: 220
  },
  {
    id: "status",
    label: "Status",
    widget: "status",
    width: 140
  },
  {
    id: "amount",
    label: "Amount",
    widget: "number",
    width: 150
  }
];


const ROW_DATA = [
  {
    date: "2025-01-03",
    purchaseOrder: "PO-24001",
    reference: "REF-90121",
    vendorName: "TechZone Solutions",
    status: "Approved",
    amount: 38500
  },
  {
    date: "2025-01-08",
    purchaseOrder: "PO-24002",
    reference: "REF-90145",
    vendorName: "OfficeMart India",
    status: "Pending",
    amount: 12400
  },
  {
    date: "2025-01-15",
    purchaseOrder: "PO-24003",
    reference: "REF-90178",
    vendorName: "CleanPro Services",
    status: "Completed",
    amount: 7600
  }];

export {COLUMNS_GROUPS,ROW_DATA};